/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ResourceFilterName = {
    Zipcode: 'zipcode',
    Manufacturer: 'manufacturer',
    Type: 'type',
    InstalledPower: 'installed_power',
    GeneratorKeys: 'generator_keys'
} as const;
export type ResourceFilterName = typeof ResourceFilterName[keyof typeof ResourceFilterName];


export function instanceOfResourceFilterName(value: any): boolean {
    for (const key in ResourceFilterName) {
        if (Object.prototype.hasOwnProperty.call(ResourceFilterName, key)) {
            if (ResourceFilterName[key as keyof typeof ResourceFilterName] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ResourceFilterNameFromJSON(json: any): ResourceFilterName {
    return ResourceFilterNameFromJSONTyped(json, false);
}

export function ResourceFilterNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResourceFilterName {
    return json as ResourceFilterName;
}

export function ResourceFilterNameToJSON(value?: ResourceFilterName | null): any {
    return value as any;
}

export function ResourceFilterNameToJSONTyped(value: any, ignoreDiscriminator: boolean): ResourceFilterName {
    return value as ResourceFilterName;
}

